import isPopupAssignedToSigner from './isPopupAssignedToSigner';

export default popup => isPopupAssignedToSigner(window.Share.getSignerAddress())(popup);



// WEBPACK FOOTER //
// ./src-react/Popups/helpers/isPopupAssignedToCurrentSigner.jsx